// szolgáltatás-hozzárendelés típus-badge — a jel a KÖZÖS badge-katalógusból jön (`domain-badge.tsx`,
// `assignmentType` fogalom): billing → info + nyugta-ikon (számlázandó), tracking → muted + szem-ikon
// („csak figyeljük" — sosem számlázott). ez a fájl csak a kényelmes, névre szóló API-t tartja meg.
import { DomainBadge } from '@/components/shared/domain-badge';

export interface ServiceTypeBadgeProps {
  type: string;
  /** A megjelenített (lokalizált) címke — a hívó adja `t('serviceAssignments.typeLabel.…')`-ből. */
  label: string;
  className?: string;
}

export function ServiceTypeBadge({ type, label, className }: ServiceTypeBadgeProps): JSX.Element {
  return <DomainBadge kind="assignmentType" value={type} label={label} className={className} />;
}
